import { render, staticRenderFns } from "./product-specs.vue?vue&type=template&id=666b26ed&scoped=true&"
import script from "./product-specs.vue?vue&type=script&lang=js&"
export * from "./product-specs.vue?vue&type=script&lang=js&"
import style0 from "./product-specs.vue?vue&type=style&index=0&id=666b26ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666b26ed",
  null
  
)

export default component.exports